import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { uuid } from 'uuidv4';
import { OrderDesignSelectComponent } from '@component/index';
import {
    setPartsSelectAction,
    yourDesignDeleteAction,
    newDesignAction,
} from '@app/react/action';
import {
    DesignSet,
    RecommendDesignFromJSON,
    ArrowType,
    OrderType,
    KINTEKI,
    ENTEKI,
    MAKIWARA,
    FULL,
    SEMI,
    PartsProduct,
} from '@app/react/const/type';
import type { AppState } from '@app/react/reducer';
import { useOrderPathParams } from '@app/react/contexts/useOrderPathParams';
import { KEY } from '@container/Dialog/DeleteDesignDialogContainer';

const selectRecommendDesigns = (state: AppState) => state.recommendDesign.items;

const selectDefaultUnit = (arrowType: ArrowType, orderType: OrderType) => (state: AppState): PartsProduct | null => (
    state.defaultUnit[arrowType]?.[orderType]
);

const selectYourDesign = (at: ArrowType, ot: OrderType) => (
    state: AppState,
): Array<DesignSet> => {
    if (at === KINTEKI && ot === FULL) {
        return state.yourDesign.param.kintekiFull;
    } if (at === KINTEKI && ot === SEMI) {
        return state.yourDesign.param.kintekiSemi;
    } if (at === ENTEKI && ot === FULL) {
        return state.yourDesign.param.entekiFull;
    } if (at === ENTEKI && ot === SEMI) {
        return state.yourDesign.param.entekiSemi;
    } if (at === MAKIWARA && ot === FULL) {
        return state.yourDesign.param.makiwaraFull;
    }
    return [];
};

export const OrderDesignSelectContainer: FC = () => {
    const dispatch = useDispatch();
    const { arrowType, orderType } = useOrderPathParams();

    const defaultUnit = useSelector(selectDefaultUnit(arrowType, orderType));

    const recommendDesignState = useSelector(selectRecommendDesigns);
    const x = recommendDesignState
        .filter(
            (row) => row.arrow_type === arrowType && row.order_type === orderType,
        )
        .map((row) => row.designs.map((item) => RecommendDesignFromJSON(item)));
    const recommendDesign = x.reduce((acc, item) => acc.concat(item), []);

    const yourDesign = useSelector(selectYourDesign(arrowType, orderType));

    const onSelectDesign = (item: DesignSet) => {
        if (item.unit === null && defaultUnit !== null) {
            console.log('unit null, fallback to default unit');
            item.unit = defaultUnit;
        }

        if (item.baseId === null) {
            item.baseId = uuid();
        }

        dispatch(setPartsSelectAction.started({ arrowType, orderType, item }));
    };

    const handleNewDesign = (item: DesignSet) => {
        if (item.unit === null && defaultUnit !== null) {
            console.log('unit null, fallback to default unit');
            item.unit = defaultUnit;
        }

        item.baseId = uuid();

        dispatch(newDesignAction({ item }));
    };

    const handleShowDialog = (item: DesignSet) => {
        const payload = { arrowType, orderType, item };
        const meta = {
            dialogInfo: {
                key: KEY,
                autoClose: true,
                userData: item,
            },
        };
        dispatch(yourDesignDeleteAction(payload, meta));
    };

    return (
        <OrderDesignSelectComponent
            recommendDesignItems={recommendDesign}
            yourDesignItems={yourDesign}
            onSelectDesign={onSelectDesign}
            handleNewDesign={handleNewDesign}
            showDialog={handleShowDialog}
        />
    );
};
